// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import Tooltip from "@insite/mobius/Tooltip";
import getQuantityTooltipStyles from "@store/Framework/Common/Utilities/getQuantityTooltipStyles";
import React, { FocusEvent, useCallback, useMemo } from "react";

const useQuantityData = (
    model: ProductModel | CartLineModel,
    value: string | number,
    sizeVariant: TextFieldPresentationProps["sizeVariant"] = "default",
    isProductCard?: boolean,
) => {
    const quantity = Number.isNaN(Number(value)) ? 0 : Number(value);

    const _model = model as any;
    const minimum = _model.minimumOrderQty || _model.properties?.minimumOrderQty || 0;
    const multiple = _model.detail?.multipleSaleQty || _model.properties?.multipleSaleQty || 0;

    let rules = "";
    if (minimum || multiple) {
        const rulesList = [];

        if (multiple) {
            rulesList.push(translate("The quantity must be a multiple of {0}.", multiple.toString()));
        }

        if (minimum && minimum !== multiple) {
            rulesList.push(translate("The minimum required quantity is {0}.", minimum.toString()));
        }

        rules = rulesList.join(" ");
    }

    const tooltipStyles = useMemo(
        () => getQuantityTooltipStyles(sizeVariant, isProductCard),
        [sizeVariant, isProductCard],
    );

    const onFocusHandler = useCallback((event: FocusEvent<HTMLInputElement>) => {
        (
            document.querySelector(
                `label[for="${event.currentTarget.getAttribute("id")}"] [class*="TooltipClickable"]`,
            ) as any
        )?.click();
    }, []);

    const textFieldProps: TextFieldProps = {
        onFocus: rules ? onFocusHandler : undefined,
        step: multiple || undefined,
        error:
            rules && ((minimum && quantity < minimum) || (multiple && quantity % multiple !== 0)) ? rules : undefined,
    };

    const tooltipComponent = rules ? <Tooltip {...tooltipStyles} text={rules} /> : null;

    return {
        minimum,
        multiple,
        onFocusHandler,
        rules,
        textFieldProps,
        tooltipComponent,
        tooltipStyles,
    };
};

export default useQuantityData;
